import { axiosInstance } from "@/lib/axios-instance";
import { IWorkspace } from "@/types/data-models";

export type Workspace = IWorkspace;

interface WorkspaceResponse {
  status: string;
  result: IWorkspace;
}

export interface OpportunityTask {
  name: string;
  completed: boolean;
  credits: number;
  completed_on?: Date;
}

export interface TasksResponse {
  status: string;
  tasks: OpportunityTask[];
  message?: string;
}

export interface CreateWorkspaceRequest {
  opportunity_name: string;
  opportunity_type: string;
  opportunity_private?: boolean;
}

export interface CreateWorkspaceResponse {
  status: string;
  message?: string;
  result: IWorkspace;
}

export const workspaceApi = {
  getWorkspace: async (workspaceId: string) => {
    const response = await axiosInstance.get<WorkspaceResponse>(
      "/fetch_opportunity",
      {
        params: {
          opportunity_id: workspaceId,
        },
      }
    );
    return response.data;
  },
  generateClientProfile: async (opportunityId: string, context: string) => {
    const response = await axiosInstance.post("/generate_client_profile", {
      opportunity_id: opportunityId,
      context,
    });
    return response.data;
  },
  getPortalWorkspace: async (workspaceId: string) => {
    const response = await axiosInstance.get<WorkspaceResponse>(
      "/fetch_portal_opportunity",
      {
        params: {
          opportunity_id: workspaceId,
        },
      }
    );
    return response.data;
  },
  getPortalWorkspaceBySlug: async (slug: string) => {
    const response = await axiosInstance.get<WorkspaceResponse>(
      "/fetch_portal_opportunity_by_slug",
      {
        params: {
          slug,
        },
      }
    );
    return response.data;
  },
  fetchExistingSlugs: async (): Promise<string[]> => {
    const response = await axiosInstance.get<{ status: string; slugs: string[] }>(
      "/fetch_portal_slugs"
    );
    return response.data.slugs;
  },
  fetchInboundEmailSlugs: async (): Promise<string[]> => {
    const response = await axiosInstance.get<{ status: string; slugs: string[] }>(
      "/inbound-email-slugs"
    );
    return response.data.slugs;
  },
  updateWorkspace: async (
    workspaceId: string,
    data: Partial<IWorkspace>
  ): Promise<WorkspaceResponse> => {
    const response = await axiosInstance.post("/edit_opportunity_data", data, {
      params: {
        opportunity_id: workspaceId,
      },
    });
    return response.data;
  },
  fetchOpportunityTasks: async (
    opportunityId: string
  ): Promise<TasksResponse> => {
    const response = await axiosInstance.get<TasksResponse>(
      "/fetch_opportunity_tasks",
      {
        params: { opportunity_id: opportunityId },
      }
    );
    return response.data;
  },
  createWorkspace: async (
    data: CreateWorkspaceRequest
  ): Promise<CreateWorkspaceResponse> => {
    const response = await axiosInstance.post("/create_opportunity", data);
    return response.data;
  },
};
